export const CRM_PROFILE_DEFAULT_VALUES = {
    crm: {
        logInPassCredentials: false,
        logInUrl: '',
        integrationType: '',
        enrollmentFlow: 'redirect',
        createProfileUrl: '',
        forgotPasswordUrl: ''
    },
    disableResetPassword: false,
    isLoyaltyProgramAssignedToProvider: false,
    isGhaBoxChecked: false,
    offerDual: false
};


// WEBPACK FOOTER //
// ./src/constants/CrmProfileDefaultValues.js